import React, { useState, useEffect, useRef } from 'react'
import { Helmet } from "react-helmet-async";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import "intl-tel-input/build/js/utils";
function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    phone: ''
  })
  const phoneInputRef = useRef(null);
  const itiRef = useRef(null);
  useEffect(() => {
    if (!phoneInputRef.current) return;

    itiRef.current = intlTelInput(phoneInputRef.current, {
      initialCountry: "auto",
      nationalMode: false,        // Full international number
      separateDialCode: false,    // Avoid splitting dial code
      autoPlaceholder: "polite",
      geoIpLookup: (callback) => {
        fetch("https://ipapi.co/json")
          .then(res => res.json())
          .then(data => callback(data.country_code))
          .catch(() => callback("us"));
      }
    });

    return () => itiRef.current.destroy();
  }, []);






  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {

    e.preventDefault()
    const iti = itiRef.current;


    const phone = itiRef.current.getNumber(); // E.164 or empty

    if (!phone || phone.length < 8) {
      alert("Please enter a phone number");
      return;
    }
    const payload = { ...formData, phone };

    try {
      const response = await fetch(process.env.REACT_APP_API_URL_EMAIL + '/send-enquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      const result = await response.json();
      if (response.ok) {

        alert(result.message || 'Message sent successfully!');
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: '',

        })
        if (iti) {
          iti.setNumber(""); // <- this resets the input
        }
      } else {
        alert('Failed to send message. Please try again.')
      }
    } catch (error) {
      console.error(error)
      alert('An error occurred. Please try again later.')
    }
  }

  return (
    <>    <Helmet>
      <title>Contact Us | Primedale Tours & Travel</title>

      <meta
        name="description"
        content="Contact Primedale Tours & Travel for safari bookings, tour packages, travel inquiries, and custom travel planning across Kenya and Africa."
      />

      <meta
        name="keywords"
        content="contact Primedale Tours, Kenya travel agency contact, safari bookings Kenya, tour inquiries, travel agency Nairobi"
      />

      <link
        rel="canonical"
        href="https://primedaletours.com/contact"
      />

      {/* Open Graph */}
      <meta property="og:title" content="Contact Us | Primedale Tours & Travel" />
      <meta
        property="og:description"
        content="Get in touch with Primedale Tours & Travel for safari tours, travel packages, and expert travel assistance in Kenya and Africa."
      />
      <meta property="og:url" content="https://primedaletours.com/contact" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Primedale Tours & Travel" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Contact Us | Primedale Tours & Travel" />
      <meta
        name="twitter:description"
        content="Reach out to Primedale Tours & Travel for safari bookings, tour planning, and travel support."
      />
    </Helmet>
      <div>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
          <div className="container py-5">
            <div className="row justify-content-center py-5">
              <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
                <h1 className="display-3 text-white animated slideInDown">
                  Contact Us
                </h1>

              </div>
            </div>
          </div>
        </div>
        {/* Contact Start */}
        <div className="container-xxl py-5">
          <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
              <h6 className="section-title bg-white text-center footer-color px-3">
                Contact Us
              </h6>
              <h1 className="mb-5 ">Contact Us For Any Query</h1>
            </div>
            <div className="row g-4">
              <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                <h5 className='footer-color'>Get In Touch</h5>
                <p className="mb-4">
                  We respond to inquires as soon as possible.
                </p>
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0 navyblue-bg"
                    style={{ width: 50, height: 50 }}
                  >
                    <i className="fa fa-map-marker-alt text-white" />
                  </div>
                  <div className="ms-3">
                    <h5 className="icon-color">Office</h5>
                    <p className="mb-0">View Park Towers, Nairobi, Kenya</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0 navyblue-bg"
                    style={{ width: 50, height: 50 }}
                  >
                    <i className=" fa fa-phone-alt text-white" />
                  </div>
                  <div className="ms-3">
                    <h5 className="icon-color">Mobile</h5>
                    <p className="mb-0">+254745715136</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0 navyblue-bg"
                    style={{ width: 50, height: 50 }}
                  >
                    <i className="fa fa-envelope-open text-white" />
                  </div>
                  <div className="ms-3">
                    <h5 className="icon-color">Email</h5>
                    <p className="mb-0">info@primedaletours.com</p>
                  </div>
                </div>

              </div>
              <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                <iframe
                  className="position-relative rounded w-100 h-100"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d997.2045773463923!2d36.81540659409879!3d-1.2828400822015553!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f10d23912632b%3A0xa3e642f1ab7822a8!2sView%20Park%20Towers%2C%20Utalii%20St%2C%20Nairobi!5e0!3m2!1sen!2ske!4v1771750051468!5m2!1sen!2ske"
                  frameBorder={0}
                  style={{ minHeight: 300, border: 0 }}
                  allowFullScreen=""
                  aria-hidden="false"
                  tabIndex={0}
                />
              </div>
              <div
                className="col-lg-4 col-md-12 wow fadeInUp"
                data-wow-delay="0.5s"
              >
                <form onSubmit={handleSubmit} method="POST">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          name='name'
                          className="form-control"
                          id="name"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        <label htmlFor="name">Your Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Your Email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        <label htmlFor="email">Your Email</label>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group intl-input-wrapper">
                        <input
                          type="tel"
                          id='phone'
                          name='phone'
                          ref={phoneInputRef}
                          className="form-control"
                          placeholder="Your Phone"
                        />

                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="subject"
                          name="subject"
                          placeholder="Subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                        <label htmlFor="subject">Subject</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          placeholder="Leave a message here"
                          id="message"
                          style={{ height: 100 }}
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                        // defaultValue={""}
                        />
                        <label htmlFor="message">Message</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button className="navyblue-bg  w-100 py-3" type="submit">
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Contact End */}
      </div>
    </>
  )
}

export default Contact
